module.exports = __webpack_public_path__ + "img/FPG-5.7171114f.jpg";